import { InjectionToken } from "@angular/core";

export const JWT_KEY_NAME = new InjectionToken<string>("jwtKeyName");


